const BbddColors = {
    colors: {
        color1: '#480c0c', // Equivalente aproximado de '#0c2b48'
        color2: '#651717', // Equivalente aproximado de '#173f65'
        color3: '#812020', // Equivalente aproximado de '#205481'
        color4: '#b64949', // Equivalente aproximado de '#4981b6'
        color5: '#c56767', // Equivalente aproximado de '#6796c5'
        color6: '#d5a6a6', // Equivalente aproximado de '#93b6d3'
    },
}

export default BbddColors;